import React from 'react'
import Star from '../Icon/Star'

const changeTextColor = hexcolor => {
  if (!hexcolor) return 'white'
  var r = parseInt(hexcolor.substr(1, 2), 16)
  var g = parseInt(hexcolor.substr(3, 2), 16)
  var b = parseInt(hexcolor.substr(5, 2), 16)

  return (r * 299 + g * 587 + b * 114) / 1000 < 128 ? 'white' : 'black'
}
const changeBgColor = hexcolor => {
  var r = parseInt(hexcolor.substr(1, 2), 16)
  var g = parseInt(hexcolor.substr(3, 2), 16)
  var b = parseInt(hexcolor.substr(5, 2), 16)

  return `rgba(${r + 200},${g + 200},${b + 200})`
}

export default function Back({
  artistName,
  type,
  title,
  artistImg,
  color = '#696969',
  description,
  style,
  date = null,
  place = null,
  ...props
}) {
  const textColor = changeTextColor(color)

  return (
    <svg
      viewBox="0 0 540 850"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{
        filter: 'drop-shadow(0px 0px 5px rgba(0,0,0,0.5))',
        ...style,
      }}
      {...props}
    >
      <def>
        <style type="text/css">
          @import url(https://fonts.googleapis.com/css?family=Noto+Sans+JP);
        </style>
      </def>
      <defs>
        <pattern id="image" height="1" width="1" viewBox="0 0 512 512">
          <image
            width="512"
            height="512"
            xlinkHref={artistImg}
            preserveAspectRatio="xMidYMid slice"
          />
        </pattern>
      </defs>
      <defs>
        <filter
          id="box-filter"
          filterUnits="objectBoundingBox"
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
        >
          <feDropShadow
            dx="0"
            dy="0"
            stdDeviation="20"
            floodColor="#000000"
            floodOpacity="0.1"
          />
        </filter>
      </defs>
      <rect width="540" height="850" rx="30" ry="30" fill="white" />
      <rect
        width="540"
        height="850"
        rx="30"
        ry="30"
        fill={color}
        opacity="0.2"
      />
      <rect
        x="20"
        y="20"
        width="500"
        height="80"
        fill={color}
        opacity="0.8"
        rx="20"
        ry="20"
        filter="url(#box-filter)"
      />
      <svg
        y="729"
        width="540"
        height="121"
        viewBox="0 0 540 121"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0.807617H540V90.9999C540 107.568 526.569 121 510 121H30C13.4315 121 0 107.568 0 90.9999V0.807617Z"
          fill={color}
          opacity="0.8"
        />
      </svg>
      <Icon type={type} textColor={textColor} />
      {type === 'ticket' && <TicketDetail date={date} place={place} />}
      <foreignObject
        fontWeight="700"
        fontSize="30"
        x="100"
        y="22"
        width="340"
        height="80"
        fontFamily="Noto Sans JP"
      >
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{ display: 'table', width: '340px', height: '80px' }}
        >
          <p
            style={{
              display: 'table-cell',
              textAlign: 'center',
              verticalAlign: 'middle',
              color: textColor,
              whiteSpace: 'pre-wrap',
              lineHeight: 1.2,
            }}
          >
            {title}
          </p>
        </div>
      </foreignObject>
      <foreignObject
        fontSize="24"
        width="480"
        height="370"
        x="30"
        y="135"
        fill={textColor}
        fontFamily="Noto Sans JP"
        style={{ whiteSpace: 'pre-wrap' }}
      >
        <div xmlns="http://www.w3.org/1999/xhtml">{description}</div>
      </foreignObject>
      <circle cx="58" cy="792" r="5.5%" fill="url(#image)" />
      <text
        x="120"
        y="802"
        fontSize="32"
        fill={textColor}
        fontFamily="Noto Sans JP"
      >
        {artistName}
      </text>
    </svg>
  )
}

const TicketDetail = ({ date, place }) => {
  let higherY = 670
  let lowerY = 700

  if (date && place) {
    higherY = 565
    lowerY = 595
  }

  return (
    <>
      <text
        x="30"
        y={higherY}
        fontWeight="600"
        fontSize="24"
        fontFamily="Noto Sans JP"
      >
        Date
      </text>
      <text x="30" y={lowerY} fontSize="24" fontFamily="Noto Sans JP">
        {date}
      </text>
      <text
        x="30"
        y="640"
        fontWeight="600"
        fontSize="24"
        fontFamily="Noto Sans JP"
      >
        Place
      </text>
      <foreignObject
        fontSize="24"
        width="480"
        height="80"
        x="30"
        y="643"
        fill="white"
        fontFamily="Noto Sans JP"
        style="white-space: pre-wrap;"
      >
        <div xmlns="http://www.w3.org/1999/xhtml">{place}</div>
      </foreignObject>
    </>
  )
}

const Icon = ({ type, textColor }) => {
  switch (type) {
    case 'ticket':
      return (
        <svg
          x="28"
          y="28"
          width="65"
          height="65"
          viewBox="0 0 99 99"
          fill="none"
        >
          <path
            d="M80.834 37.007L62.993 19.166c-1.554-1.555-4.103-1.555-5.72 0L48.82 27.62l.56.56c.497.497.497 1.305 0 1.74l-.871.87c-.497.498-1.306.498-1.74 0l-.56-.559-27.042 27.042c-1.555 1.555-1.555 4.103 0 5.72l17.841 17.841c1.554 1.554 4.103 1.554 5.72 0l27.042-27.042-.746-.746c-.498-.497-.498-1.305 0-1.74l.87-.87c.498-.498 1.306-.498 1.74 0l.747.745 8.454-8.454c1.554-1.555 1.554-4.103 0-5.72zm-6.403 4.165l-6.03 6.03-2.362-2.362c-.498-.497-1.306-.497-1.74 0l-.871.87c-.497.498-.497 1.306 0 1.741l2.362 2.362-24.618 24.68c-.746.746-1.865.746-2.61 0L25.506 61.44c-.746-.746-.746-1.865 0-2.611L50.124 34.21l2.176 2.176c.498.497 1.306.497 1.74 0l.871-.87c.497-.498.497-1.306 0-1.741l-2.176-2.176 6.03-6.03c.746-.746 1.865-.746 2.611 0L74.37 38.56c.808.746.808 1.865.062 2.611zm-15.23-3.17c-.498-.497-1.306-.497-1.741 0l-.87.87c-.498.498-.498 1.306 0 1.74l2.61 2.612c.498.497 1.306.497 1.741 0l.87-.87c.498-.498.498-1.306 0-1.741l-2.61-2.611z"
            fill={textColor}
          />
        </svg>
      )
    case 'audio':
      return (
        <svg
          x="28"
          y="28"
          width="65"
          height="65"
          viewBox="0 0 99 99"
          fill="none"
        >
          <path
            d="M79.933 51.816v-.267c0-1.273-.2-5.892-.335-7.298C77.858 28.449 65.002 17 49.067 17c-8.035 0-15.6 3.013-21.359 8.503-5.69 5.49-9.105 13.056-9.574 21.158-.067.87-.134 3.08-.134 4.419v17.14a6.286 6.286 0 0 0 6.294 6.294h5.021a6.286 6.286 0 0 0 6.294-6.294V52.084a6.286 6.286 0 0 0-6.294-6.294h-4.62c1.273-12.855 11.584-22.43 24.439-22.43 12.587 0 22.764 9.107 24.17 21.627 0 .2.067.469.067.803h-4.62a6.286 6.286 0 0 0-6.293 6.294V68.22a6.286 6.286 0 0 0 6.294 6.294h4.954A6.286 6.286 0 0 0 80 68.22V52.084c-.067-.067-.067-.2-.067-.268zm-54.166.402h2.008c.737 0 1.34.603 1.34 1.34v13.19c0 .736-.603 1.338-1.34 1.338h-2.008c-.737 0-1.34-.602-1.34-1.339v-13.19c0-.736.603-1.339 1.34-1.339zm47.805 14.53c0 .736-.602 1.338-1.339 1.338h-2.008c-.737 0-1.34-.602-1.34-1.339v-13.19c0-.736.603-1.339 1.34-1.339h2.008c.737 0 1.34.603 1.34 1.34v13.19z"
            fill={textColor}
          />
        </svg>
      )
    case 'magazine':
      return (
        <svg
          x="28"
          y="28"
          width="65"
          height="65"
          viewBox="0 0 99 99"
          fill="none"
        >
          <path
            d="M26 65.594V33a5 5 0 0 1 5-5h37a5 5 0 0 1 5 5v32.594a5 5 0 0 1-5 5H31a5 5 0 0 1-5-5z"
            stroke={textColor}
            strokeWidth="5"
          />
          <path
            d="M26 55.906l4.239-5.177a4 4 0 0 1 6.19 0l1.29 1.576a4 4 0 0 0 6.066.144l9.713-10.773a4 4 0 0 1 6.019.088L71.53 55.906"
            stroke={textColor}
            strokeWidth="5"
          />
        </svg>
      )
    case 'video':
      return (
        <svg
          x="28"
          y="28"
          width="65"
          height="65"
          viewBox="0 0 99 99"
          fill="none"
        >
          <path
            d="M73.864 24H24.545A9.533 9.533 0 0 0 15 33.545v30.228a9.533 9.533 0 0 0 9.546 9.545h49.318a9.533 9.533 0 0 0 9.545-9.545V33.545A9.533 9.533 0 0 0 73.864 24zm3.818 39.773a3.83 3.83 0 0 1-3.818 3.818H24.545a3.83 3.83 0 0 1-3.818-3.818V33.545a3.83 3.83 0 0 1 3.819-3.818h49.318a3.83 3.83 0 0 1 3.818 3.818v30.228z"
            fill={textColor}
          />
          <path
            d="M55.473 46.973l-9.29-5.41c-.637-.381-1.4-.381-1.973 0-.637.383-1.019 1.019-1.019 1.719v10.69c0 .7.382 1.337 1.019 1.719.318.19.636.255 1.018.255.318 0 .7-.064 1.018-.255l9.29-5.346c.637-.381 1.019-1.018 1.019-1.718-.064-.7-.445-1.336-1.082-1.654zM29.764 34.246h-3.818c-.7 0-1.273.572-1.273 1.272v1.273c0 .7.573 1.273 1.273 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.273c0-.7-.573-1.272-1.273-1.272zM29.764 42.582h-3.818c-.7 0-1.273.573-1.273 1.273v1.273c0 .7.573 1.272 1.273 1.272h3.818c.7 0 1.273-.572 1.273-1.273v-1.272c0-.7-.573-1.273-1.273-1.273zM29.764 50.918h-3.818c-.7 0-1.273.573-1.273 1.273v1.272c0 .7.573 1.273 1.273 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.272c0-.7-.573-1.273-1.273-1.273zM29.764 59.254h-3.818c-.7 0-1.273.573-1.273 1.273V61.8c0 .7.573 1.273 1.273 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.273c0-.7-.573-1.273-1.273-1.273zM72.654 34.246h-3.818c-.7 0-1.272.572-1.272 1.272v1.273c0 .7.572 1.273 1.272 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.273c0-.7-.573-1.272-1.273-1.272zM72.654 42.582h-3.818c-.7 0-1.272.573-1.272 1.273v1.273c0 .7.572 1.272 1.272 1.272h3.818c.7 0 1.273-.572 1.273-1.273v-1.272c0-.7-.573-1.273-1.273-1.273zM72.654 50.918h-3.818c-.7 0-1.272.573-1.272 1.273v1.272c0 .7.572 1.273 1.272 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.272c0-.7-.573-1.273-1.273-1.273zM72.654 59.254h-3.818c-.7 0-1.272.573-1.272 1.273V61.8c0 .7.572 1.273 1.272 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.273c0-.7-.573-1.273-1.273-1.273z"
            fill={textColor}
          />
        </svg>
      )
  }
}
